import React, { PropsWithChildren, useContext } from "react";

import { Paper, Stack } from "@mui/material";

import { MeetingInfoContext } from "../../../../context";

import DropdownMuteButton from "./components/drop-down-mute-button";
import DropDownAudioButton from "./components/drop-down-audio-button";
import DropDownCameraButton from "./components/drop-down-camera-button";
import ContentShareButton from "./components/content-share-button";
import LeaveCallButton from "./components/leave-call-button";
import PopupMessage from "./components/popup-message";
import { MeetingLayout } from "../../../../types";

interface WebControlBarProps {
  layout: MeetingLayout;
  startWithVideo?: boolean;
  startWithAudio?: boolean;
  startMuted?: boolean;
  contentShare?: boolean;
}

const WebControlBar: React.FC<PropsWithChildren<WebControlBarProps>> = ({
  layout,
  startWithVideo = false,
  startWithAudio = true,
  startMuted = false,
  contentShare = false,
  children,
}) => {
  const preferredCamera = layout === "remote" ? "poly studio" : undefined;
  const preferredMic = layout === "remote" ? ["DJI", "RX"] : undefined;

  const { errorMessage, connected } =
    useContext(MeetingInfoContext);
  const disabled =
    (errorMessage != null && errorMessage.length > 0) || !connected;

  const [deviceError, setDeviceError] = React.useState<string | null>(null);

  const onMicFound = (found: string | undefined) => {
    if (!found) {
      if (layout === "remote") {
        setDeviceError(
          "Could not find DJI Mic Mini, please check it is connected."
        );
      } else {
        console.log("Mic not found");
      }
    }
  };

  return (
    <Paper
      elevation={20}
      sx={{
        mt: 4,
        padding: 1,
        borderRadius: "10px",
        height: "fit-content",
        width: "fit-content",
        position: "fixed",
        bottom: "10px",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 100,
        display: disabled ? "none" : "flex",
        backdropFilter: `blur(20px)`,
        backgroundColor: `rgba(255, 255, 255, 0.8)`,
      }}
    >
      <Stack spacing={1} direction={"row"} justifyContent="space-around">
        <DropdownMuteButton
          disabled={disabled}
          startMuted={startMuted}
          preferredMicList={preferredMic}
          onMicFound={onMicFound}
        />
        <DropDownAudioButton
          disabled={disabled}
          startWithAudio={startWithAudio}
        />
        <DropDownCameraButton
          disabled={disabled}
          startWithVideo={startWithVideo}
          cameraType={preferredCamera}
        />
        {contentShare && (
          <ContentShareButton disabled={disabled} />
        )}
        {children}
        <LeaveCallButton />
      </Stack>
      <PopupMessage
        message={deviceError || ""}
        open={deviceError != null && deviceError.length > 0}
        severity={"error"}
        onClose={() => setDeviceError(null)}
      />
    </Paper>
  );
};

export default WebControlBar;
